import { Group, Title } from '@mantine/core';
import { IconType } from 'react-icons';
import { DEFAULT_ICON_SIZE } from 'utils/general';

interface Props {
  title: string;
  Icon: IconType;
}

export const PatientDetailsTitle = ({ title, Icon }: Props) => {
  return (
    <Group gap={'xs'}>
      <Icon color={'var(--mantine-color-blue-5)'} size={DEFAULT_ICON_SIZE} />
      <Title order={2} c={'blue'}>
        {title}
      </Title>
    </Group>
  );
};
